import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { Formik, Field as Fieldmik } from 'formik';
import { Form as FormUi, Segment, Button } from 'semantic-ui-react';
import * as yup from 'yup';
import Axios from 'axios';
import moment from 'moment';

import AddTitleBar from '../../components/titleBar/addTitleBar';
import APP_CONSTANTS from '../../config/constants';
import { DateData } from '../formikInput/date';
import ActiveVendorBills from './activeVendorBills';
import LoadingPlaceholder from '../placeholder/loadingPlaceholder';

//Dropdowns
import PurchaseOrderVendorDropdown from '../dropdowns/purchaseOrderVendorDropdown';
import PaymentModeDropdown from '../dropdowns/paymentModeDropdown';
import BankDropdown from '../dropdowns/bankDropdown';

//Actions 
import { updatePayment, getPayments } from '../../redux/actions/paymentActions';
import { getVendorBills } from '../../redux/actions/billActions';
import PaidBills from './paidBills';


const ViewPayment = (props) => {

    const { getPayments, updatePayment, getVendorBills, vendorBillsData, paymentData, paymentLoading, vendorBillsLoading } = props;


    const [paymentModeData, setPaymentModeData] = useState([]);
    const [mappedPayment, setMappedPayment] = useState([]);
    const [paymentName, setPaymentName] = useState(paymentData && paymentData.length > 0 && paymentData[0].paymentModeName)

    useEffect(() => {
        const id = props.location.state.id
        const vendorCode = props.location.state.vendorCode
        const edit = true

        getPayments(id);
        getVendorBills(vendorCode, edit);

        let token = localStorage.getItem('apiToken')
        let userId = localStorage.getItem('userId')
        let customerNo = localStorage.getItem('customerNo')
        let data = JSON.stringify
            ({
                "customerNumber": customerNo,
                "userId": userId,
                "customer_no": customerNo,
                "user_id": userId,
                "customerNo": customerNo,
                "paymentId": id,
            })

        Axios.post(`${APP_CONSTANTS.BASE_URL}purchase/bill/getBillsPaymentMapping`, data, {
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': token
            }
        }).then((response => {
            setMappedPayment(response.data.data)

        }))
            .catch(error => console.log(error))


    }, [getPayments])

    if (paymentLoading || vendorBillsLoading) {
        return (
            <React.Fragment>
                <LoadingPlaceholder />
            </React.Fragment>
        )
    } else {




        const paymentSelected = childData => {

            let addedPaymentMode = paymentModeData.filter(e => {
                console.log("Payment Code ", e.paymentModeCode)
                return e.paymentModeCode === childData
            })
            setPaymentName(addedPaymentMode && addedPaymentMode.length > 0 && addedPaymentMode[0].paymentModeName)

            console.log("ChildData", childData, paymentName, addedPaymentMode)
        }



        let activeVendorBillsData = [];

        vendorBillsData && paymentData && vendorBillsData.map((o, i) => {
            let temp = {}

            function containsBillId(obj, list) {
                var i;
                for (i = 0; i < list.length; i++) {
                    if (list[i].billId === obj.billId) {
                        return true;
                    }
                }

                return false;
            }

            temp.checkbox = containsBillId(o, paymentData[0].bills)
            temp.billDate = o.billDate
            temp.vendorBillNo = o.billNo
            temp.vendorCode = o.vendorId
            temp.billDueDate = o.expectedPaymentDate
            temp.billAmount = o.billAmount
            temp.amountDue = o.pendingAmount
            temp.billId = o.billId
            temp.payment = ''

            activeVendorBillsData[i] = temp
        })

        let mappedBills = [];
        mappedPayment && mappedPayment.map((bill, index) => {
            let temp = {}
            temp.billDate = bill.bill_details[0].billDate
            temp.billReferenceNo = bill.bill_details[0].billReferenceNo
            temp.vendorBillNo = bill.bill_details[0].billNo
            temp.billDueDate = bill.bill_details[0].expectedPaymentDate
            temp.amountDue = bill.pendingAmount
            temp.paidAmount = bill.paidAmount
            temp.billAmount = bill.bill_details[0].billAmount

            mappedBills[index] = temp
        })


        //Formik
        const initialValues = {
            vendorId: paymentData ? paymentData[0].vendorId : "",
            vendorName: paymentData ? paymentData[0].vendorCode : '',
            vendorBranch: paymentData ? paymentData[0]?.vendorBranchCode : '',
            branchCode: paymentData ? paymentData[0]?.branchCode : '',
            paymentAmount: paymentData ? paymentData[0].paymentAmount : '',
            paymentDate: paymentData ? new Date(paymentData[0].paymentDate) : '',
            paymentMode: paymentData ? paymentData[0].paymentModeCode : '',
            bank: paymentData ? paymentData[0].bankCode : '',
            chequeNo: paymentData ? paymentData[0].chequeNo : '',
            refNo: paymentData ? paymentData[0].paymentReferenceNo : '',
            tds: paymentData ? paymentData[0].tdsAmount : '',
            paidAmount: paymentData ? paymentData[0].paidAmount : '',
            activeVendorBills: activeVendorBillsData,
            activeVendorBillSelected: [],
            tdsOnBills: [],
            transactionDate: paymentData ? new Date(paymentData[0].transactionDate) : '',
            notes: '',
            finalPayment: '',
        }

        const validateSchema = yup.object().shape({
            vendorName: yup.mixed().required('Partner Name is Required'),
            paymentAmount: yup.mixed().required('Payment Amount is Required'),
            paymentDate: yup.mixed().required('Payment Date is Required'),
            paymentMode: yup.mixed().required('Payment Mode is Required'),
            bank: yup.mixed().required('Bank is Required'),
            refNo: yup.mixed().required('Reference Number is Required'),
            transactionDate: yup.mixed().required('Transaction Date is Required'),
        })

        const onSubmit = (values, onSubmitProps) => {
            console.log("Product Onsubmit", values)

            const customerNumber = localStorage.getItem('customerNo');
            const userId = localStorage.getItem('userId');

            const bills = [];
            values.activeVendorBillSelected.map((product, index) => {
                let temp = {}
                temp.billId = product.billId
                temp.paidAmount = product.payment
                temp.pendingAmount = product.amountDue
                bills[index] = temp
            });

            const updatePaymentData = {
                customerNo: customerNumber,
                userId: userId,
                paymentReferenceNo: values.refNo,
                vendorCode: paymentData[0].vendorCode,
                paymentDate: moment(values.paymentDate).format("DD-MM-YYYY"),
                transactionDate: moment(values.transactionDate).format("DD-MM-YYYY"),
                paymentModeCode: values.paymentMode,
                paymentModeName: values.paymentMode.name,
                approvalStatus: "2",
                chequeNo: values.chequeNo,
                bankCode: values.bank,
                completePayment: values.paymentAmount === values.finalPayment ? 1 : 0,
                paidAmount: values.finalPayment,
                paymentAmount: values.paymentAmount,
                tdsAmount: values.adjustmentAmount,
                pendingAmount: values.amount,
                remarks: '',
                vendorLedgerId: "",
                cashLedgerId: values.cashLedger,
                bills: bills,
            };

            updatePayment(updatePaymentData).then(() => {
                setTimeout(() => { onSubmitProps.setSubmitting(false) }, 4000)
            });

        };


        return (
            <React.Fragment>
                <AddTitleBar title="View Payment" LinkName="/payment" />
                <div className="m-2">
                    <Formik
                        initialValues={initialValues}
                        validationSchema={validateSchema}
                        onSubmit={onSubmit}
                    >
                        {({ touched, errors, values, isSubmitting, handleSubmit }) => (
                            <>
                                <Segment>
                                    <div className="ui form tiny">
                                        <FormUi.Group >
                                            <FormUi.Field width="2">
                                                <label className="labelName mt-2">Vendor</label>
                                            </FormUi.Field>
                                            <FormUi.Field width="5">
                                                <Fieldmik
                                                    component={PurchaseOrderVendorDropdown}
                                                    disabled
                                                    name="vendorName"
                                                    placeholder="Partner Name"
                                                    value={values.vendorName}
                                                    transporterMasterId={values.vendorId} />
                                                {touched.vendorName && errors.vendorName ? <strong className="w3-text-red w3-tiny font-weight-bold">{errors.vendorName}</strong> : ''}
                                            </FormUi.Field>
                                            <FormUi.Field width="1" />
                                            <FormUi.Field width="2">
                                                <label className="labelName mt-2">Vendor Branch</label>
                                            </FormUi.Field>
                                            <FormUi.Field width="5">
                                                <Fieldmik name="vendorBranch" disabled />
                                            </FormUi.Field>
                                            <FormUi.Field width="2">
                                                <label className="labelName mt-2">Branch</label>
                                            </FormUi.Field>
                                            <FormUi.Field width="5">
                                                <Fieldmik name="branchCode" disabled />
                                            </FormUi.Field>
                                        </FormUi.Group>
                                        <PaidBills
                                            mappedBills={mappedBills}
                                        />

                                        <FormUi.Group >
                                            <FormUi.Field width="3">
                                                <label className="labelName mt-2">Payment Amount</label>
                                            </FormUi.Field>
                                            <FormUi.Field width="4">
                                                <Fieldmik name="paymentAmount" placeholder="Payment Amount" readOnly />
                                                {touched.paymentAmount && errors.paymentAmount ? <strong className="w3-text-red w3-tiny font-weight-bold">{errors.paymentAmount}</strong> : ''}
                                            </FormUi.Field>
                                            <FormUi.Field width="1" />
                                            <FormUi.Field width="3">
                                                <label className="labelName mt-2">Payment Date</label>
                                            </FormUi.Field>
                                            <FormUi.Field width="2">
                                                <DateData
                                                    readOnly
                                                    name={`paymentDate`}
                                                    autoComplete="off"
                                                    popperClassName="dateTime"
                                                    dateFormat="dd-MM-yyyy"
                                                    placeholderText="Date"
                                                    selected={values.paymentDate}
                                                    timeIntervals={5}
                                                    customInput={<FormUi.Input autoComplete="off" className="dateWidth" icon="time" iconPosition="left" />}
                                                />
                                                {touched.paymentDate && errors.paymentDate ? <strong className="w3-text-red w3-tiny font-weight-bold">{errors.paymentDate}</strong> : ''}
                                            </FormUi.Field>
                                        </FormUi.Group>
                                        <FormUi.Group >
                                            <FormUi.Field width="3">
                                                <label className="labelName mt-2">Payment Mode</label>
                                            </FormUi.Field>
                                            <FormUi.Field width="4">
                                                <Fieldmik disabled component={PaymentModeDropdown} name="paymentMode" placeholder="Payment Mode" value={values.paymentMode} setPaymentData={setPaymentModeData} paymentSelected={paymentSelected} paymentModeEdit={values.paymentMode} />
                                                {touched.paymentMode && errors.paymentMode ? <strong className="w3-text-red w3-tiny font-weight-bold">{errors.paymentMode}</strong> : ''}
                                            </FormUi.Field>
                                            <FormUi.Field width="1" />
                                        </FormUi.Group>
                                        <FormUi.Group>
                                            {console.log("Payment  Selected ===> ", paymentName)}
                                            {paymentName === "CASH" ?
                                                // <>
                                                //     <FormUi.Field width="3">
                                                //         <label className="labelName mt-2">Select Cash Ledger</label>
                                                //     </FormUi.Field>
                                                //     <FormUi.Field width="4">
                                                //         <Fieldmik disabled component={BankDropdown} name="cashLedger" placeholder="Select Cash Ledger" value={values.cashLedger} />
                                                //         {touched.cashLedger && errors.cashLedger ? <strong className="w3-text-red w3-tiny font-weight-bold">{errors.cashLedger}</strong> : ''}
                                                //     </FormUi.Field>
                                                // </> 
                                                ""
                                                :
                                                <>
                                                    <FormUi.Field width="3">
                                                        <label className="labelName mt-2">Select Bank</label>
                                                    </FormUi.Field>
                                                    <FormUi.Field width="4">
                                                        <Fieldmik disabled component={BankDropdown} name="bank" placeholder="Select Bank" value={values.bank} />
                                                        {touched.bank && errors.bank ? <strong className="w3-text-red w3-tiny font-weight-bold">{errors.bank}</strong> : ''}
                                                    </FormUi.Field>
                                                    {paymentName === "CHEQUE" ?
                                                        <>
                                                            <FormUi.Field width="1" />
                                                            <FormUi.Field width="3">
                                                                <label className="labelName mt-2">Cheque No</label>
                                                            </FormUi.Field>
                                                            <FormUi.Field width="4">
                                                                <Fieldmik readOnly name="chequeNo" placeholder="Cheque No" />
                                                                {touched.chequeNo && errors.chequeNo ? <strong className="w3-text-red w3-tiny font-weight-bold">{errors.chequeNo}</strong> : ''}
                                                            </FormUi.Field>
                                                        </>
                                                        :
                                                        ""
                                                    }
                                                </>}
                                        </FormUi.Group>
                                        <FormUi.Group >
                                            <FormUi.Field width="3">
                                                <label className="labelName mt-2">Reference No</label>
                                            </FormUi.Field>
                                            <FormUi.Field width="4">
                                                <Fieldmik name="refNo" readOnly placeholder="Reference Number" />
                                                {touched.refNo && errors.refNo ? <strong className="w3-text-red w3-tiny font-weight-bold">{errors.refNo}</strong> : ''}
                                            </FormUi.Field>
                                            <FormUi.Field width="1" />
                                            <FormUi.Field width="3">
                                                <label className="labelName  mt-2">Transaction Date</label>
                                            </FormUi.Field>
                                            {console.log("Payment Values", values)}
                                            <FormUi.Field width="2">
                                                <DateData
                                                    readOnly
                                                    name={`transactionDate`}
                                                    autoComplete="off"
                                                    popperClassName="dateTime"
                                                    dateFormat="dd-MM-yyyy"
                                                    placeholderText="Date"
                                                    selected={values.transactionDate}
                                                    timeIntervals={5}
                                                    customInput={<FormUi.Input autoComplete="off" className="dateWidth" icon="time" iconPosition="left" />}
                                                />
                                                {touched.transactionDate && errors.transactionDate ? <strong className="w3-text-red w3-tiny font-weight-bold">{errors.transactionDate}</strong> : ''}
                                            </FormUi.Field>
                                        </FormUi.Group>
                                        <FormUi.Group>
                                            <FormUi.Field width="3">
                                                <label className="labelName mt-2">TDS</label>
                                            </FormUi.Field>
                                            <FormUi.Field width="4">
                                                <Fieldmik name="tds" readOnly />
                                                {touched.tds && errors.tds ? <strong className="w3-text-red w3-tiny font-weight-bold">{errors.tds}</strong> : ''}
                                            </FormUi.Field>
                                            <FormUi.Field width="1" />
                                            <FormUi.Field width="3">
                                                <label className="labelName mt-2">Paid Amount</label>
                                            </FormUi.Field>
                                            <FormUi.Field width="4">
                                                <Fieldmik name="paidAmount" readOnly />
                                                {touched.paidAmount && errors.paidAmount ? <strong className="w3-text-red w3-tiny font-weight-bold">{errors.paidAmount}</strong> : ''}
                                            </FormUi.Field>
                                        </FormUi.Group>
                                        {/* {vendorBillsLoading ? <LoadingPlaceholder /> : <ActiveVendorBills viewmode={true} />} */}

                                    </div>
                                </Segment>

                            </>
                        )}
                    </Formik>
                </div>
            </React.Fragment>
        )
    }


}

const mapStatetoProps = state => ({
    paymentData: state.getPaymentsData.payments.data,
    paymentLoading: state.getPaymentsData.isLoading,
    vendorBillsData: state.getBillsData.bills.data,
    vendorBillsLoading: state.getBillsData.isLoading
})


export default connect(mapStatetoProps, { updatePayment, getVendorBills, getPayments })(ViewPayment)


